import { DAY_MS_AT_1X, PAUSED, type SpeedSetting } from './speed';

/**
 * The simulation's clock (M288, taken out of the page's frame so it holds whatever draws, or nothing): each frame's
 * elapsed time at the speed chosen fills an accumulator, and each whole day in it is one tick. Sable Reserve's caps: a
 * frame counts for at most `MAX_FRAME_MS`, and at most `MAX_TICKS_PER_FRAME` days are stepped in one, so a slow machine
 * slows the clock rather than spiraling; past the cap the accumulator keeps at most one day, never a backlog.
 */
export const MAX_FRAME_MS = 250;
export const MAX_TICKS_PER_FRAME = 32;

/** The days to step this frame and the accumulator after them. */
export function clockSteps(accumulator: number, elapsedMs: number, speed: SpeedSetting): { steps: number; accumulator: number } {
  if (speed <= PAUSED) return { steps: 0, accumulator };
  let acc = accumulator + (Math.max(0, Math.min(elapsedMs, MAX_FRAME_MS)) * speed) / DAY_MS_AT_1X;
  let steps = 0;
  while (acc >= 1 && steps < MAX_TICKS_PER_FRAME) {
    acc -= 1;
    steps++;
  }
  if (steps === MAX_TICKS_PER_FRAME) acc = Math.min(acc, 1);
  return { steps, accumulator: acc };
}
